import {Component, OnDestroy, OnInit} from '@angular/core';
import { WorkflowItemKeyDirective } from '@workflow/directives/workflow-item-key/workflow-item-key.directive';
import {
	LandoltElement,
	LandoltRingHelper,
} from '@workflow/components/questionnaire/questionnaire-item/special-question/landolt-test/landolt-rings';
import {BehaviorSubject, Subscription} from 'rxjs';
import {tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';
import * as Reducers from '@app/store/reducers';
import { isNil } from 'lodash';

interface LandoltValues {
	zeit?: number,
	fehler?: number,
	selected?: boolean[];
}

@Component({
	selector: 'workflow-landolt-test-epilog',
	templateUrl: './landolt-test-epilog.component.html',
	styleUrls: [
		'./landolt-test.component.scss',
		'./landolt-test-epilog.component.scss',
		'../../../../../../workflow/components/navigator/wizard-view/wizard-view.component.scss',
	]
})
export class LandoltTestEpilogComponent implements OnInit, OnDestroy {
	landoltElements: LandoltElement[] = [];
	language: string;

	landoltValues$: BehaviorSubject<LandoltValues> = new BehaviorSubject<LandoltValues>(null);
	alternativeEingabe$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	private subscription: Subscription = new Subscription();

	constructor(
		public workflowItemKey: WorkflowItemKeyDirective<LandoltValues>,
		private store: Store<{locale?: string}>,
	) {
		this.landoltElements = LandoltRingHelper.getLandoltRingMatrix();
	}

	ngOnInit(): void {
		const workflowValuePipe = this.workflowItemKey.property$.pipe(
			tap(val => {
				this.landoltValues$.next((val?.fehler || val?.zeit) ? val : null);
				this.alternativeEingabe$.next(isNil(val.selected));
			}),

		);
		const langPipe = this.store.pipe(
			select(Reducers.getSettings),
			tap(state => {
				this.language = state.locale;
			}),
		);

		this.subscription.add(workflowValuePipe.subscribe());
		this.subscription.add(langPipe.subscribe());
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}
